import { render, staticRenderFns } from "./Copyrights.vue?vue&type=template&id=318253cc&"
import script from "./Copyrights.vue?vue&type=script&lang=ts&"
export * from "./Copyrights.vue?vue&type=script&lang=ts&"
import style0 from "./Copyrights.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Copyrights.vue"
export default component.exports